module.exports = __webpack_public_path__ + "images/if6_trend_stable.svg?cc79da4d96910e445e636725e3a39dc9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/if6_trend_stable.svg
// module id = VVy2
// module chunks = 0